import { useMutation, useQueryClient } from '@tanstack/react-query';
import costCategoriesApi from '@/features/dashboard/costCategories/api/costCategoriesApi.ts';
import { costCategoriesApiQueryKeys } from '@/features/dashboard/costCategories/api/costCategoriesApi.queryKeys.ts';
import { toast } from 'sonner';

export default function useCreateCostCategory() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: costCategoriesApi.create,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: costCategoriesApiQueryKeys.all(),
      });
      toast.success('Kategoria kosztów została utworzona');
    },
    onError: (error: Error) => {
      toast.error('Wystąpił błąd', {
        description:
          error.message || 'Wystąpił błąd podczas tworzenia kategorii kosztów.',
      });
    },
  });
}
